
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ValueSection from './components/ValueSection';
import AdvantageSection from './components/AdvantageSection';
import ProcessSection from './components/ProcessSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ValueSection />
        <AdvantageSection />
        <ProcessSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
